import LoginFormContainer from './LoginForm.container';
import LoginForm from './LoginForm';

export default LoginFormContainer(LoginForm);
